import { render, staticRenderFns } from "./XFormSelect.vue?vue&type=template&id=16ce7f18&"
import script from "./XFormSelect.vue?vue&type=script&lang=js&"
export * from "./XFormSelect.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports